import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class Months extends Component{
  constructor() {
    super();
    this.state = {
      months: [],
      customers: null,
      total_amount: null,
      total_boxes: null
    }
  }

  getMonths() {
    const token = localStorage.getItem("admin-token")
    const headers = { "Content-Type": "application/json",};
    headers["Authorization"] = `Token ${token}`;
    return fetch("/api/admin/months",
      {
        headers,
        method: "GET",
      })
      .then(res => {
        return res.json().then(data => {
          this.setState({...data})
        })
      })
  }

  componentDidMount(){
    if (this.props.isAuthenticated) {
      this.getMonths()
    }
  }

  render() {
    return(
      <div className="Admin-Months">
        <h1>Months</h1>
        <div className="d-flex">
          <h4>Antal kunder: {this.state.customers}</h4>
          <h4>Antal lådor: {this.state.total_boxes}</h4>
          {
            this.state.total_amount
            ?
            <h4>
              Total: {this.state.total_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}kr
            </h4>
            :
            null
          }
        </div>
        <div className="Products-body">
          <table>
            <thead>
              <tr>
                <th>Månad</th>
                <th>Redigera</th>
              </tr>
            </thead>
            <tbody>
              {
                this.state.months.map(item => {
                  return(
                    <tr key={item.id}>
                      <td>{item.name}</td>
                      <td>
                        <Link to={`/backoffice/months/${item.id}`} className="table-button">
                          Granska
                        </Link>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default Months;



// WEBPACK FOOTER //
// ./src/containers/admin/containers/Months.jsx